import { render, staticRenderFns } from "./SettingsRewardCenter.vue?vue&type=template&id=3c0af7ea&scoped=true"
import script from "./SettingsRewardCenter.vue?vue&type=script&lang=js"
export * from "./SettingsRewardCenter.vue?vue&type=script&lang=js"
import style0 from "./SettingsRewardCenter.vue?vue&type=style&index=0&id=3c0af7ea&prod&lang=scss&scoped=true"
import style1 from "./SettingsRewardCenter.vue?vue&type=style&index=1&id=3c0af7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0af7ea",
  null
  
)

export default component.exports